import { jsx as s } from "react/jsx-runtime";
import { useEffect as d } from "react";
import { FlagProvider as l } from "@unleash/proxy-client-react";
import { useFlag as D, useFlags as O, useFlagsStatus as Y, useUnleashClient as C, useUnleashContext as M, useVariant as P } from "@unleash/proxy-client-react";
import { UnleashToolbarProvider as T } from "@unleash/toolbar/react";
const _ = {
  URL: "VITE_UNLEASH_URL",
  CLIENT_KEY: "VITE_UNLEASH_CLIENT_KEY"
}, i = {
  ANONYMOUS_USER_ID: "anonymous",
  REFRESH_INTERVAL: 30,
  // seconds
  METRICS_INTERVAL: 30
  // seconds
}, L = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
function c(e, o) {
  return L[e] || o || "";
}
function m(e, o) {
  return !!(e && o);
}
function N(e) {
  return e ? { ...e } : {};
}
function v(e) {
  return {
    userId: (e == null ? void 0 : e.userId) || i.ANONYMOUS_USER_ID,
    properties: N(e == null ? void 0 : e.properties)
  };
}
function p() {
  import("@unleash/toolbar/toolbar.css");
}
function h({
  appName: e,
  context: o,
  url: a,
  clientKey: R,
  enableToolbar: S,
  unleashConfig: U,
  children: n
}) {
  const E = a || c(_.URL), u = R || c(_.CLIENT_KEY), r = S ?? !1, t = m(E, u);
  if (d(() => {
    t && r && p();
  }, [t, r]), !t)
    return /* @__PURE__ */ s(
      l,
      {
        config: { url: "https://disabled", clientKey: "disabled", appName: e },
        startClient: !1,
        children: n
      }
    );
  const I = v(o), f = {
    url: E,
    clientKey: u,
    appName: e,
    context: I,
    refreshInterval: i.REFRESH_INTERVAL,
    metricsInterval: i.METRICS_INTERVAL,
    ...U
  };
  return r ? /* @__PURE__ */ s(
    T,
    {
      FlagProvider: l,
      config: f,
      children: n
    }
  ) : /* @__PURE__ */ s(l, { config: f, children: n });
}
export {
  i as DEFAULTS,
  _ as ENV_KEYS,
  h as UnleashProvider,
  N as buildProperties,
  v as buildUnleashContext,
  m as isUnleashConfigured,
  D as useFlag,
  O as useFlags,
  Y as useFlagsStatus,
  C as useUnleashClient,
  M as useUnleashContext,
  P as useVariant
};
